import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconSportsGymnastics = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconSportsGymnastics",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "m478-118-18-362-140-40H80q-17 0-28-11t-12-29 12-28 28-12h200l250-179q13-9 28-7t26 14q11 14 9 31t-16 27l-131 94h114l286-165q11-7 25-4t24 16q11 12 9 28t-15 25L580-480l-18 362q-1 16-13 27t-31 11q-16 0-27-11t-13-27M240-640q-33 0-56-23t-24-57 24-56 56-24 57 24 23 56-23 57-57 23"
  })
}));
IconSportsGymnastics.displayName = 'IconSportsGymnastics';